import {ZoomPanPinchControls} from "ZoomPanPinchControls";
import { MADECanvasRenderer, MADEP5Renderer } from "renderer/Renderer";
import * as THREE from 'three';

class ScavengerHuntMapRenderer {
  canvas: HTMLCanvasElement
  renderer: THREE.WebGLRenderer
  scene: THREE.Scene
  camera: THREE.PerspectiveCamera
  controls: ZoomPanPinchControls

  init = () => {
    this.renderer.setPixelRatio( window.devicePixelRatio );
    this.renderer.setSize( window.innerWidth, window.innerHeight );

    const geometry = new THREE.PlaneGeometry( 3, 3, 3 );
    const texture = new THREE.TextureLoader().load('/img/nightlife/teen_lounge.png' ); 
    const material = new THREE.MeshBasicMaterial( { map: texture } );
    const cube = new THREE.Mesh( geometry, material );
    this.scene.add( cube );

    this.camera.position.z = 5;

    this.controls.start();

  }

  animate = () => {
    requestAnimationFrame(() => this.animate());

    this.render();
  }

  render = () => {
    this.renderer.render( this.scene, this.camera );
  }

  constructor(canvas: HTMLCanvasElement) {
    this.canvas = canvas
    this.scene = new THREE.Scene();
    this.scene.background = new THREE.Color( 0xffffff );
    // Allow camera Z value to be very small with the map still visible
    this.camera = new THREE.PerspectiveCamera( 40, window.innerWidth / window.innerHeight, 0.0001, 1000 );
    this.renderer = new THREE.WebGLRenderer( { antialias: true, canvas: this.canvas } );
    this.controls = new ZoomPanPinchControls(this.renderer.domElement, this.camera.position);

    this.init();
    this.animate();

    window.addEventListener( 'resize', (event) => this.onWindowResize(event) );
  }


  onWindowResize(event) {
    event.preventDefault();
    document.getElementsByTagName("html")[0].style.overflow = "hidden";
    document.getElementsByTagName("html")[0].style.height = "100%";
    document.getElementById("app")!.style.height = "100%";
    this.renderer.setPixelRatio( window.devicePixelRatio );
    this.renderer.setSize( window.innerWidth, window.innerHeight );

    this.camera.aspect = window.innerWidth / window.innerHeight;
    this.camera.updateProjectionMatrix();


  }
}

export class ScavengerHuntMapDelegate implements MADECanvasRenderer {
  canvas?: HTMLCanvasElement
  renderer?: ScavengerHuntMapRenderer

  start(canvas: HTMLCanvasElement) {
    this.canvas = canvas;
    this.renderer = new ScavengerHuntMapRenderer(canvas);

    return true
  }
}
